import { createAsyncThunk } from "@reduxjs/toolkit";
import genericUtility from "../../services/utility/GenericUtility";
import ProductApiService from "../apiServices/ProductApiService";
import AdminGeneralApiService from "../apiServices/AdminGeneralApiService";

// Thunk to fetch messages from an API
export const fetchAllFeedbacks = createAsyncThunk(
  "admin/fetchAllFeedbacks",
  async () => {
    const response: any = await AdminGeneralApiService.getAllFeedbacks();

    return response.contents;
  }
);

export const fetchSellRequirements = createAsyncThunk(
  "admin/fetchSellRequirements",
  async () => {
    const currentUserLocation = await genericUtility.getCurrentUserLocation();
    const response: any = await AdminGeneralApiService.fetchSellRequirements(
      currentUserLocation
    );

    response.contents = [
      {
        searchString: "batter",
        supplyCount: 0,
      },
      {
        searchString: "apartments for rent",
        supplyCount: 0,
      },
    ];
    return response.contents;
  }
);

export const fetchUiConfigurations = createAsyncThunk(
  "admin/getUiConfigurations",
  async () => {
    const response: any = await AdminGeneralApiService.getUiConfigurations();
    // Response is the config array directly (not wrapped in {contents})
    return Array.isArray(response) ? response : response.contents;
  }
);

export const fetchAnnouncements = createAsyncThunk(
  "admin/fetchAnnouncements",
  async () => {
    const response: any = await AdminGeneralApiService.getAnnouncements();

    return response.contents;
  }
);


const AdminThunk = {
  fetchAllFeedbacks,
  fetchSellRequirements,
  fetchUiConfigurations,
  fetchAnnouncements,
};
export default AdminThunk;
